import React from 'react';
import { describe, type ValidationMap } from '@elliemae/ds-props-helpers';
import { DSTabsPropTypes } from './react-desc-prop-types.js';
import { DSTabsContext, DSTabsCrossRefContext } from './DSTabsCTX.js';
import { TabsContent } from './parts/tabsContent/TabsContent.js';
import { useTabs } from './config/useTabs.js';
import { useCrossRef } from './config/useCrossRef.js';

import type { DSTabsT } from './react-desc-prop-types.js';
import { TAB_TYPES } from './constants/index.js';

const DSTabs = (props: DSTabsT.Props): JSX.Element => {
  const ctx = useTabs(props);
  const crossRefsCtx = useCrossRef();

  const { type } = props;

  if (type === TAB_TYPES.SUBTABS) {
    return (
      <DSTabsContext.Provider value={ctx}>
        <TabsContent />
      </DSTabsContext.Provider>
    );
  }

  return (
    <DSTabsCrossRefContext.Provider value={crossRefsCtx}>
      <DSTabsContext.Provider value={ctx}>
        <TabsContent />
      </DSTabsContext.Provider>
    </DSTabsCrossRefContext.Provider>
  );
};

DSTabs.displayName = 'DSTabs';
const DSTabsWithSchema = describe(DSTabs);
DSTabsWithSchema.propTypes = DSTabsPropTypes as unknown as ValidationMap<DSTabsT.Props>;

export { DSTabs, DSTabsWithSchema };
export default DSTabs;
